<template>
<nav class="navbar navbar-transparent navbar-absolute gradient-donapp z-9">
  <div class="">
    <div class="navbar-header">
      <img height="22px" src="../../assets/logo-donapp-white.png">
    </div>
    <div class="user">
      <div class="photo grey-bg" :style="{ 'background-image': 'url(' + (user.img || '../../static/img/profile_icon.svg') + ')' }" />
      <div class="info">
        <span>{{ displayName }}</span>
      </div>
      <router-link to="/change-role">
        <i class="icon-switch_user"/>
      </router-link>
    </div>
  </div>
</nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'topbar',
  computed: {
    ...mapState({
      user: state => state.user,
      displayName: state => state.user.firstName + ' ' + state.user.lastName
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/config.scss';

.navbar {
  height: $topbarHeight;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 29px;
  padding-right: 20px;
  border-radius: 0px;
  @include shadow();
}

.navbar-header {
  line-height: 14px;
}

.user {
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  line-height: 16px;
}

img {
  vertical-align: initial;
}

i,
.info > span {
  font-size: 16px;
  line-height: 16px;
}

.user .photo {
  width: 20px;
  height: 20px;
  overflow: hidden;
  border-radius: 50%;
  z-index: 5;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0 rgba(0, 0, 0, 0.12),
    0 8px 10px -5px rgba(0, 0, 0, 0.2);
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

.photo,
.info {
  margin-right: 10px;
}

.user .photo img {
  width: 100%;
}

// .material-icons,
i[class^='icon-'],
.info span {
  color: $white;
}

@media screen and (min-width: 0px) and (max-width: 990px) {
  .user {
    display: none;
  } /* don't show it on small screens */
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TopBar.vue